<script lang="ts" setup>
import {computed} from "vue";
const notificationsStore = useNotificationsStore();
const {
  notificationPermission,
  isNotificationSupported,
  enableBrowserNotifications,
} = useFirebaseNotification();
const {
  modalEnableNotificationsClosed,
} = storeToRefs(notificationsStore);
const {userLoggedIn} = useWadAuth();

const allowBrowserNotifications = () => {
  modalEnableNotificationsClosed.value = true;
  enableBrowserNotifications();
}

const closeEnable = () => {
  modalEnableNotificationsClosed.value = true;
}

const showEnableNotificationsModal = computed(() => {
  return !modalEnableNotificationsClosed.value && notificationPermission.value !== 'granted';
});
</script>

<template>
  <div class="wad4-firebase-settings" v-if="isNotificationSupported && userLoggedIn">
    <client-only>
      <CommonWadModal
          v-model="showEnableNotificationsModal"
          :showCloseIcon="false"
          :title="'Push notifications'"
      >
        <template #content>
          Stay in the loop! Enable push notifications to get all the updates about sessions, giveaways and other activities.
        </template>
        <template #controls>
          <button @click="allowBrowserNotifications" class="wad4-button-primary wad4-button--width-full">Yes, enable notifications</button>
          <button @click="closeEnable" class="wad4-button-secondary wad4-button--width-full">No, thank you</button>
        </template>
      </CommonWadModal>
    </client-only>
  </div>
</template>

<style lang="scss">
.wad4-firebase-settings {
}
</style>
